/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LATE_FEE_REVIEW_TABS } from 'containers/billing/review/late-fee-review/settings'
import { DATA_GRID_DEFAULT_PINNED_COLUMNS } from 'settings/constants/dataGrid'

import { SerializedDateRange } from './persistentReviewDateRangeTypes'

const { READY_FOR_INVOICE } = LATE_FEE_REVIEW_TABS

type PinnedColumns = typeof DATA_GRID_DEFAULT_PINNED_COLUMNS

export interface PersistentLateFeeReviewState {
  selectedTab: string
  selectedFilterId: string
  pinnedColumns: PinnedColumns
  dateRange: SerializedDateRange | null
}

const initialState: PersistentLateFeeReviewState = {
  selectedTab: READY_FOR_INVOICE,
  selectedFilterId: '',
  pinnedColumns: { ...DATA_GRID_DEFAULT_PINNED_COLUMNS },
  dateRange: null,
}

const lateFeeReviewSlice = createSlice({
  name: 'persistentLateFeeReview',
  initialState: { ...initialState },
  reducers: {
    setSelectedTab: (state, action: PayloadAction<string>) => {
      state.selectedTab = action.payload
    },
    setSelectedFilterId: (state, action: PayloadAction<string>) => {
      state.selectedFilterId = action.payload
    },
    setPinnedColumns: (state, action: PayloadAction<PinnedColumns>) => {
      state.pinnedColumns = action.payload
    },
    setDateRange: (state, action: PayloadAction<SerializedDateRange | null>) => {
      state.dateRange = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setSelectedTab, setSelectedFilterId, setPinnedColumns, setDateRange, resetState } = lateFeeReviewSlice.actions

// The persisted slice can predate a key, so every selector falls back to the initial value.
interface StateWithLateFeeReview {
  persistentLateFeeReview?: Partial<PersistentLateFeeReviewState>
}

export const selectSelectedTab = (state: StateWithLateFeeReview): string => state.persistentLateFeeReview?.selectedTab ?? READY_FOR_INVOICE
export const selectSelectedFilterId = (state: StateWithLateFeeReview): string => state.persistentLateFeeReview?.selectedFilterId ?? ''
export const selectPinnedColumns = (state: StateWithLateFeeReview): PinnedColumns =>
  state.persistentLateFeeReview?.pinnedColumns ?? initialState.pinnedColumns
export const selectDateRange = (state: StateWithLateFeeReview): SerializedDateRange | null =>
  state.persistentLateFeeReview?.dateRange ?? null

export default lateFeeReviewSlice.reducer
